import Routes from "../../../../pages/Masters/Suppliers/OCBinnacle";
import RoutesNewEdit from "../../../../pages/Masters/Suppliers/OCBinnacle/NewEdit";
//import RoutesDetail from "../../../../pages/Masters/Suppliers/MasterSuppliers/Detail";

const routerOCBinnacle = [
    {
        key: "suppliers",
        path: "/masters/suppliers/ocbinnacle",
        element: <Routes />,
    },
    {
        key: "suppliers",
        path: "/masters/suppliers/ocbinnacle/new",
        element: <RoutesNewEdit />,
    },
    // {
    //     key: "routes",
    //     path: "/transactions/routes/detail/:id",
    //     element: <RoutesDetail />,
    // },
    // {
    //     key: "routes",
    //     path: "/transactions/routes/:id",
    //     element: <RoutesDetail />,
    // },
]

export default routerOCBinnacle
